import { DIALOG_TYPE, LAUNCH_CALLER, LayoutConfig } from '@spartacus/storefront';
import { SampleOrderModalComponent } from './sample-order-modal.component';

export const sampleOrderModalLayoutConfig: LayoutConfig = {
  launch: {
    [LAUNCH_CALLER.SAMPLE_ORDER]: {
      inlineRoot: true,
      component: SampleOrderModalComponent,
      dialogType: DIALOG_TYPE.DIALOG,
    },
  },
};
